import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../providers/AuthUserProvider';
import { hasAuthSession } from '../utils/authTokenStorage';

import { Loader } from './AppRoutes';
import { Paths } from './Paths';

export const AppPrivate = () => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (!user && !hasAuthSession()) {
    return (
      <Navigate replace to={Paths.Login} state={{ from: location.pathname }} />
    );
  }

  if (isLoading) {
    return <Loader open />;
  }

  if (!user) {
    return <Navigate to={Paths.Login} state={{ from: location.pathname }} />;
  }

  return <Outlet />;
};
